import {createMuiTheme} from 'material-ui/styles';
import red from 'material-ui/colors/red';

export const overrideTheme = createMuiTheme({
    overrides: {
        MuiCollapse: {
            entered: {
                overflow: 'visible',
            },
        },
    },
});

export const styles = (theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    hasErrors: {
        color: red[500],
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    dialogActionsBtn: {
        margin: '8px 19px',
    },
    expandedPanelFieldContainer: {
        margin: '5px 0px',
        width: '100%',
        display: 'inline-block',
    },
    expandedPanelLocations: {
        height: '150px',
    },
    locationsMultiSelect: {
        width: '100%',
        position: 'relative',
        top: '0',
    },
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    fullWidth: {
        width: '80%',
    },
    selectMenuItem: {
        fontSize: '14px',
        padding: '5px 15px',
    },
    reviewSelects: {
        marginTop: '15px',
    },
    productsSelects: {
        marginTop: '15px',
        background: 'rgba(216, 216, 216, 0.85)',
        paddingBottom: '10px',
    },
    selectMenuItemSpan: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    selectProjectsCustom: {
        width: '90%',
        marginRight: '40px',
    },
    selectProjectsField: {
        paddingRight: 0,
    },
    removeProductBtn: {
        display: 'inline-flex',
    },
    addAnotheProductBtn: {
        marginTop: '20px',
    },
    loadingText: {
        textAlign: 'center',
        fontSize: '1.2em',
        color: '#666',
        margin: '30px 0 15px 0',
    },
    imageEdit: {
        maxHeight: 500,
        margin: 'auto',
        display: 'flex',
    },
});



// WEBPACK FOOTER //
// ./src/containers/builder/style/meta_section.js